<template>
	<div class="d-flex flex-grow-1 overflow-hidden">
		<div
			class="flex-grow-1 d-flex flex-column px-2"
			style="border: 1px solid #eee"
		>
			<v-text-field
				label="Search"
				v-model="unassignedSearch"
				class="flex-grow-0"
			/>
			<v-list dense class="flex-grow-1 pa-0 overflow-auto">
				<v-subheader>Unassigned Users</v-subheader>
				<v-list-item-group
					v-model="selectedUnassigned"
					active-class="primary white--text"
					class="field-list"
					multiple
				>
					<v-list-item
						v-for="item in unassignedFiltered"
						:key="item.Id"
						:value="item.UserId"
					>
						<v-list-item-content>
							<v-list-item-title>{{
								`${item.UserFirstName} ${item.UserLastName}`
							}}</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
				</v-list-item-group>
			</v-list>
		</div>
		<div class="flex-grow-0 d-flex">
			<div class="d-flex flex-column justify-center mx-4 flex-grow-1">
				<v-btn
					v-if="canEdit"
					class="my-2"
					color="primary"
					outlined
					text
					@click="assignUser()"
				>
					<v-icon> mdi-arrow-right </v-icon>
				</v-btn>
				<v-btn
					v-if="canEdit"
					class="my-2"
					color="primary"
					outlined
					text
					@click="unassignUser()"
				>
					<v-icon> mdi-arrow-left </v-icon>
				</v-btn>
			</div>
		</div>
		<div
			class="flex-grow-1 d-flex flex-column px-2"
			style="border: 1px solid #eee"
		>
			<v-text-field
				label="Search"
				v-model="assignedSearch"
				class="flex-grow-0"
			/>
			<v-list dense class="flex-grow-1 pa-0 overflow-auto">
				<v-subheader>Assigned users</v-subheader>
				<v-list-item-group
					v-model="selectedAssigned"
					active-class="primary white--text"
					class="field-list"
					multiple
				>
					<v-list-item
						v-for="item in assignedFiltered"
						:key="item.UserId"
						:value="item.UserId"
						class="px-1"
					>
						<v-list-item-content>
							<v-list-item-title
								>{{ item.FirstName }}
								{{ item.LastName }}</v-list-item-title
							>
						</v-list-item-content>
					</v-list-item>
				</v-list-item-group>
			</v-list>
		</div>
	</div>

	<!-- <v-card elevation="0" style="display: flex;flex-direction: column;flex-grow: 1;margin-top: 0;height: 100%;">
        <v-card-title>Assign Users</v-card-title>
        <v-card-text class="pa-0 mt-6" style="flex-grow: 1" v-if="canView">
            <div class="field-lists-container d-flex" style="height: 100%">
                <div class="col-5 hidden-list">
                    <v-text-field label="Search" v-model="unassignedSearch" />

                    <v-list dense>
                        <v-subheader>Unassigned Users</v-subheader>
                        <v-list-item-group v-model="selectedUnassigned" active-class="primary white--text"
                            class="field-list" multiple>
                            <v-list-item v-for="item in unassignedFiltered" :key="item.Id"
                                :value="item.UserId">
                                <v-list-item-content>
                                    <v-list-item-title>{{ item.UserFirstName }}
                                        {{
                                            item.UserLastName
                                        }}</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list-item-group>
                    </v-list>
                </div>
                <div class="d-flex flex-column justify-center col-2">
                    <v-btn v-if="canEdit" class="my-2" color="primary" outlined text @click="assignUser()">
                        <v-icon> mdi-arrow-right </v-icon>
                    </v-btn>
                    <v-btn v-if="canEdit" class="my-2" color="primary" outlined text @click="unassignUser()">
                        <v-icon> mdi-arrow-left </v-icon>
                    </v-btn>
                </div>
                <div class="col-5 visible-list">
                    <v-text-field label="Search" v-model="assignedSearch" />
                    <v-list dense>
                        <v-subheader>Assigned users</v-subheader>
                        <v-list-item-group v-model="selectedAssigned" active-class="primary white--text" class="field-list"
                            multiple>
                            <v-list-item v-for="item in assignedFiltered" :key="item.UserId" :value="item.UserId"
                                class="px-1">
                                <v-list-item-content>
                                    <v-list-item-title>
                                        {{ item.FirstName }}
                                        {{ item.LastName }}
                                    </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list-item-group>
                    </v-list>
                </div>
            </div>
        </v-card-text>
        <v-divider />
    </v-card> -->
</template>
<script>
import { mapGetters } from 'vuex';
import {
	AssignUsersGetters,
	ProjectContextGetters,
} from '../../../../store/getters';
import { AssignUsersActions } from '../../../../store/actions';
import { Permissions } from '../../../../enums/permissionsEnum';
import permissionsMixin from '../../../../mixins/permissionsMixin';
export default {
	name: 'AssignUser',
	mixins: [permissionsMixin],
	props: {},
	data() {
		return {
			assignedSearch: '',
			unassignedSearch: '',
			selectedUnassigned: [],
			selectedAssigned: [],
		};
	},
	computed: {
		...mapGetters({
			assigned: [AssignUsersGetters.ASSIGNEDUSERS],
			unassigned: [AssignUsersGetters.UNASSIGNEDUSERS],
			selectedProject: [ProjectContextGetters.SELECTED_PROJECT],
			loading: [AssignUsersGetters.IS_LOADING],
		}),
		assignedFiltered() {
			if (!this.assignedSearch) return this.assigned;
			return this.assigned.filter((x) => {
				let name = x.FirstName + ', ' + x.LastName;
				return name
					.toLowerCase()
					.includes(this.assignedSearch.toLowerCase());
			});
		},
		unassignedFiltered() {
			if (!this.unassignedSearch) return this.unassigned;
			return this.unassigned.filter((x) => {
				let name = x.UserFirstName + ', ' + x.UserLastName;
				return name
					.toLowerCase()
					.includes(this.unassignedSearch.toLowerCase());
			});
		},
		canView() {
			return this.hasPermissions([
				Permissions.Tools.FormBuilder.AssignUser.View,
			]);
		},
		canEdit() {
			return this.hasPermissions([
				Permissions.Tools.FormBuilder.AssignUser.Edit,
			]);
		},
	},
	mounted() {
		this.loadData();
	},
	methods: {
		assignUser() {
			this.$store
				.dispatch(AssignUsersActions.INSERT, {
					inventoryId: this.$route.params.id,
					users: this.selectedUnassigned,
				})
				.then(() => {
					this.loadData();
					(this.selectedUnassigned = []),
						(this.selectedAssigned = []);
				});
		},
		unassignUser() {
			this.$store
				.dispatch(AssignUsersActions.DELETE, {
					inventoryId: this.$route.params.id,
					users: this.selectedAssigned,
				})
				.then(() => {
					this.loadData();
					(this.selectedUnassigned = []),
						(this.selectedAssigned = []);
				});
		},
		onCancel() {
			this.$emit('cancel');
		},
		loadData() {
			this.$store.dispatch(AssignUsersActions.LOAD, {
				formId: this.$route.params.id,
				projectId: this.selectedProject.Id,
			});
		},
	},
};
</script>
